import { fetchExactagCustomerData, TagsView } from "./api"
import * as exactag from "@otto-ec/online-marketing/exactag"

export async function trackCustomerData() {
    try {
        const exactagView: TagsView | null = await fetchExactagCustomerData()
        const hasExactagData = exactagView !== null && exactagView.ls !== 0
        if (hasExactagData) {
            const exactagData = mapToExactagBody(exactagView)
            exactag.registerVerticalDataCallback("customerData", (currentData) =>
                ({ ...currentData, ...exactagData })
            )
        }
    } catch (error) {
        console.error("Failed to fetch customer's exactag data:", error)
    }
}

function mapToExactagBody(exactagView: TagsView) {
    return { ...exactagView }
}

trackCustomerData();
